import { Link } from "react-router-dom";
import { Compass } from "lucide-react";

export default function NotFound() {
  return (
    <div className="max-w-lg mx-auto px-6 py-32 text-center" data-testid="not-found">
      <Compass className="h-14 w-14 text-asf-orange mx-auto mb-6" />
      <h1 className="font-display text-6xl font-extrabold tracking-tighter">404</h1>
      <p className="text-slate-600 mt-4">We couldn't find that page.</p>
      <Link to="/" className="btn-primary inline-block mt-8 px-8 py-4">Back Home</Link>
    </div>
  );
}
